import React, { Component } from 'react'
import { Button, Container, Segment, Dropdown, Card, Icon, List, Header, Label } from 'semantic-ui-react'
import { getAllCategories } from '../../services/Categories'
import { getActiveCommOnlyPlans } from 'services/Manager'
import Config from 'Config'
import './SellerPlans.less'


class SellerPlans extends Component {

    constructor(props) {
        console.log('here')
        super(props)
        this.state = {
            orignalCategories: [],
            categories: [],
            selectedCategory: {},
            plans: [],
            isUpdateModalOpen: false,
            isAddModalOpen: false,
            modalInitialState: {},
            clonedInitialState: {},
            copyPlanID: 0
        }
    }

    componentDidMount() {
        getAllCategories().then((res) => {
            this.setState({
                categories: res.data.map((cat) => ({
                    key: cat.categoryID,
                    value: cat.categoryID,
                    text: cat.name,
                })),
                orignalCategories: res.data
            })
        }).catch((err) => {
            console.log(err);
        });
    }

    onCategoryChange = (data) => {
        this.setState({ selectedCategory: this.state.orignalCategories.find(c => c.categoryID == data.value) })
        getActiveCommOnlyPlans(data.value).then(res => {
            console.log(res.data)
            this.setState({ plans: res.data || [] })
        }
        ).catch((err) => {
            console.log(err);
        })
    }

    copyCheckoutURL = (checkoutUrl, planID) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(checkoutUrl)
                .then(() => {
                    this.setState({copyPlanID: planID})
                    setTimeout(() => {
                        this.setState({copyPlanID: 0})
                    }, 2000)
                })
        } else {
            alert("Copy operation does not supported in this browser. ")
        }
    }

    render() {
        return (
            <Container fluid className="seller-plans-container">
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header mobile-header-new ">
                            <div className="main-heading main-heading-new">
                                Payment Plans
                            </div>
                        </div>
                        <Segment>
                        <Dropdown
                            id='ddlCategory'
                            placeholder='Select Category'
                            fluid
                            selection
                            options={this.state.categories}
                            onChange={(e, data) => this.onCategoryChange(data)}
                            value={this.state.selectedCategory.value}
                        />
                    </Segment>
                    {this.state.selectedCategory.categoryID ? <Segment>
                       
                       <Card.Group>
                           {this.state.plans.map(sp => <Card /*className={`${!sp.isActive ? 'card-inactive ' : ''}${sp.isPrivate ? 'card-private ' : ''}`}*/>
                               <Card.Content>
                                   <Card.Header>{sp.displayOrder}. {sp.planName} </Card.Header>
                                   <Card.Meta>Plan Type: {sp.planType}</Card.Meta>
                                   <Card.Description>
                                        <p>
                                            {sp.trialDays > 0 && <Label className='plan-type' color='green'>Trial</Label>}
                                            {sp.commissionOnly && <Label className='plan-type' color='blue'>Commission Only</Label>}
                                            {/*(!sp.trialDays || sp.trialDays == 0) && !sp.commissionOnly && sp.isActive && <Label className='plan-type' color='blue'>Active</Label>*/}
                                        </p>
                                       <p>Price: {sp.price}</p>
                                       {Number(sp.referralFee) ? <p>Referral Fee: ${sp.referralFee || 0}</p> : <p>Commission: {sp.commission || 0}%</p>}
                                       {/*<p>Is Active: {sp.isActive ? 'Yes' : 'No'}</p>*/}
                                       {/*<p>Commission Only: {sp.commissionOnly ? 'Yes' : 'No'}</p>*/}
                                       {/*<p>Is Private: {sp.plan.isPrivate ? 'Yes' : 'No'}</p>*/}
                                       <p>Requires Payment Method: {sp.requiresPaymentMethod ? 'Yes' : 'No'}</p>
                                       {/*<p>Trial Requests Count: {sp.plan.trialRequestsCount || 0}</p>
                                       <p>Plan ID: {sp.plan.planID}</p>*/}
                                       { sp.trialDays > 0 && <p>Trial Days: {sp.trialDays || 0}</p>}
                                       <p><a target="_blank" href={`${Config.sellerWeb.url}/business/checkout/${sp.planID}`}>Checkout URL</a>&nbsp;&nbsp;
                                       <span style={{cursor:'pointer'}} title="Copy checkout link" onClick={() => this.copyCheckoutURL(`${Config.sellerWeb.url}/business/checkout/${sp.planID}`, sp.planID)}>
                                       <svg
                                           xmlns="http://www.w3.org/2000/svg" width="13.312" height="12.536" viewBox="0 0 13.312 12.536">
                                           <g id="Group_16193" data-name="Group 16193" transform="translate(0.15 0.15)">
                                               <g id="Group_16198" data-name="Group 16198" transform="translate(0 0)">
                                                   <path id="Path_29436" data-name="Path 29436" d="M10.773,78.262H0V68.276H10.773Zm-.744-9.254H9.847q-4.465,0-8.93,0c-.145,0-.2.03-.2.188q.008,4.078,0,8.157c0,.054.005.107.008.164h9.294Z" transform="translate(0 -66.026)" stroke="#000000" fill="#000000" stroke-width="0.3" />
                                                   <path id="Path_29437" data-name="Path 29437" d="M86.724.738H76.972V0H87.448V9.661h-.725Z" transform="translate(-74.436 0)" stroke="#000000" fill="#000000" stroke-width="0.3" />
                                               </g>
                                           </g>
                                       </svg>
                                       
                                       </span>
                                       &nbsp;&nbsp;&nbsp;
                                       <span>{this.state.copyPlanID == sp.planID ? 'Copied!' : ''}</span>
                                       
                                       </p>
                                       
                                   </Card.Description>
                               </Card.Content>
                           </Card>)}
                           {this.state.plans.length == 0 && "No active or commission only plans found"}
                       </Card.Group>
                   </Segment> : ''}
                    </div>
                </div>
                
                    
            </Container>
            
        )
    }
}

export default SellerPlans